import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';

import { ThreadViewComponent } from './thread-view/thread-view.component';
import { ThreadDetailModule } from '../../components/thread-detail/thread-detail.module';
import { ThreadViewEffects } from '../../redux/effects/thread-view.effects';
import { WidgetsModule } from '../../widgets/widgets.module';
import { MapTileDialogModule } from '../../components/map-tile-dialog/map-tile-dialog.module';

@NgModule({
    imports: [
        CommonModule,
        ThreadDetailModule,
        WidgetsModule,
        EffectsModule.forFeature([
            ThreadViewEffects
        ]),
        MapTileDialogModule,
    ],
    declarations: [
        ThreadViewComponent
    ]
})
export class ThreadModule { }
